import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { page } from './api-sms-reminder-lancamento';
import { dateTimeFormat, dateFormat } from '../../../util/DateUtil';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    novoRegistro: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    cursorLink: {
        cursor: 'pointer'
    },
    rowHeader: {
        fontSize: 13,
        fontWeight: '700',
    },
});

const SmsReminderTable = () => {
    const classes = useStyles();
    const [smsReminders, setSmsReminders] = useState({
        content: []
    });

    useEffect(() => {
        page(0).then((data) => {
            if (data.error) {
                console.log(data);
            } else {
                setSmsReminders(data);
            }
        })
    }, []);

    const handleChangePage = (event, newPage) => {
        page(newPage).then((data) => {
            if (data.error) {
                console.log(data.error);
            } else {
                setSmsReminders(data);
            }
        });
    };


    return (
        <>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.rowHeader}>Ano Letivo</TableCell>
                        <TableCell className={classes.rowHeader}>Cod. Dóc.</TableCell>
                        <TableCell className={classes.rowHeader}>Histórico</TableCell>
                        <TableCell className={classes.rowHeader}>Aluno</TableCell>
                        <TableCell className={classes.rowHeader}>Responsável</TableCell>
                        <TableCell className={classes.rowHeader}>Vencimento</TableCell>
                        <TableCell className={classes.rowHeader}>Vencimento Desconto</TableCell>
                        <TableCell className={classes.rowHeader}>Mensagem</TableCell>
                        <TableCell className={classes.rowHeader}>Celular Enviado</TableCell>
                        <TableCell className={classes.rowHeader}>Data Criação</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {smsReminders.content.map((sr) => (
                        <TableRow key={sr.codigo}>
                            <TableCell>{sr.lancamento.anoLetivo}</TableCell>
                            <TableCell>{sr.lancamento.codDoc}</TableCell>
                            <TableCell>{sr.lancamento.historicoLancamento.descricao}</TableCell>
                            <TableCell>{sr.lancamento.aluno.codigo} - {sr.lancamento.aluno.nome}</TableCell>
                            <TableCell>{sr.usuario.nome}</TableCell>
                            <TableCell>{dateFormat(sr.lancamento.dataVencimento)}</TableCell>
                            <TableCell>{sr.lancamento.dataDesconto ? dateFormat(sr.lancamento.dataDesconto) : '--'}</TableCell>
                            <TableCell>{sr.message}</TableCell>
                            <TableCell>{sr.celularEnviado}</TableCell>
                            <TableCell>{dateTimeFormat(sr.createdAt)}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[]}
                rowsPerPage={smsReminders.size ? smsReminders.size : 0}
                component="div"
                count={smsReminders.totalElements}
                page={smsReminders.number}
                onPageChange={handleChangePage}
                labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : " mais de " + to))}
                ActionsComponent={TablePaginationActions}
            />
        </>
    );
}

export default SmsReminderTable;